import { PlayGroup } from './play-group.js'
import { PlayGroupQuery } from './play-group-query.js'
import { PlayGroupMutation } from './play-group-mutation.js'
import { PlayGroupSubscription } from './play-group-subscription.js'
import { PlayGroupSubscriber } from './event-subscriber.js'

export const entities = [PlayGroup]
export const resolvers = [PlayGroupQuery, PlayGroupMutation, PlayGroupSubscription]
export const subscribers = [PlayGroupSubscriber]
